var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcConnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.002,
    height: 10,
    viewBox: "0 0 10.002 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_42",
    "data-name": "Exclusion 42",
    d: "M-10737,3015a5.006,5.006,0,0,1-5-5,5.007,5.007,0,0,1,5-5,5.006,5.006,0,0,1,5,5A5.006,5.006,0,0,1-10737,3015Zm-1.4-5.967h0a.688.688,0,0,0-.687.688v1.916l1.214,1.216v1.042h1.736v-1.042l1.216-1.218v-1.907a.7.7,0,0,0-.694-.694v-1.389h-.694v1.389h-1.389v-1.389h-.694v1.389Z",
    transform: "translate(10742.001 -3005)",
    fill: "#fdbb1d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConnected);
export default __webpack_public_path__ + "static/media/ic_connected.2a9bc30ab691839b9c39e052c1c3dd82.svg";
export { ForwardRef as ReactComponent };